<template>
    <div class="loginWrap_form">
        <div class="loginWrap_form_top">
            <div class="loginWrap_hidden_logo">
                <a :href="$page.props.home_url ?? '/'">
                    <IconLogo />
                </a>
            </div>
            <h1>Create a new password!</h1>
            <SetNewPasswordForm
                :token="token"
                :email="email"
            />
        </div>
    </div>
</template>


<script lang="ts">
import MainLayout from '@/layouts/MainLayout.vue';
import SideLayout from '@/layouts/SideLayout.vue';

export default {
    layout: [MainLayout, SideLayout],
};
</script>

<script setup lang="ts">
import { Link } from '@inertiajs/vue2';
import IconLogo from '@/components/icons/IconLogo.vue';
import SetNewPasswordForm from '@/components/SetNewPasswordForm.vue';

withDefaults(defineProps<{
    token?: string;
    email?: string;
}>(), {
    token: undefined,
    email: undefined,
});
</script>
